import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledDraggableContent = styled.div`
  border: 8px solid ${Colors.background};
  outline: 1px solid ${Colors.backgroundPaleBlueDark};
  box-shadow: -1px 1px 1px 1px ${Colors.lighterGray};
  border-radius: 12px;
  padding: 0 10px;
  background-color: ${Colors.backgroundPaleBlueDark};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(${({ rot }) => rot ?? 0}deg);

  cursor: pointer;
  user-select: none;
  transition:
    transform 0.3s,
    box-shadow 0.3s,
    background-color 0.3s;

  &.hidden {
    opacity: 0;
  }
  &.dragged {
  }
  &.dropped {
    top: 0;
    left: 0;
    transform: translate(0, 0) rotate(0deg);
    box-shadow: none;
  }
`;
